// extracted by mini-css-extract-plugin
module.exports = {"Text":"deleteAdmin_Text__3e8KV","ButtonContainer":"deleteAdmin_ButtonContainer__12U8K","FieldControl":"deleteAdmin_FieldControl__2TdXK"};